"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SemiAsyncStorage = void 0;
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var POSTHOG_STORAGE_KEY = '.posthog-rn.json';
var POSTHOG_STORAGE_VERSION = 'v1';
var SemiAsyncStorage = function () {
  function SemiAsyncStorage(asyncStorage) {
    (0, _classCallCheck2["default"])(this, SemiAsyncStorage);
    this._memoryCache = {};
    this.isPreloaded = false;
    this._asyncStorage = asyncStorage;
  }
  (0, _createClass2["default"])(SemiAsyncStorage, [{
    key: "preloadAsync",
    value: function preloadAsync() {
      var _this = this;
      if (this.isPreloaded) {
        return Promise.resolve();
      }
      if (this._preloadSemiAsyncStoragePromise) {
        return this._preloadSemiAsyncStoragePromise;
      }
      this._preloadSemiAsyncStoragePromise = this._asyncStorage.getItem(POSTHOG_STORAGE_KEY).then(function (res) {
        try {
          var data = res ? JSON.parse(res).content : {};
          for (var key in data) {
            _this._memoryCache[key] = data[key];
          }
        } catch (e) {
          console.warn("PostHog failed to load persisted data from storage. This is likely because the storage format is. We'll reset the storage.", e);
        } finally {
          _this.isPreloaded = true;
        }
      });
      this._preloadSemiAsyncStoragePromise["finally"](function () {
        _this._preloadSemiAsyncStoragePromise = undefined;
      });
      return this._preloadSemiAsyncStoragePromise;
    }
  }, {
    key: "persist",
    value: function persist() {
      var payload = {
        version: POSTHOG_STORAGE_VERSION,
        content: this._memoryCache
      };
      void this._asyncStorage.setItem(POSTHOG_STORAGE_KEY, JSON.stringify(payload));
    }
  }, {
    key: "getItem",
    value: function getItem(key) {
      return this._memoryCache[key];
    }
  }, {
    key: "setItem",
    value: function setItem(key, value) {
      this._memoryCache[key] = value;
      this.persist();
    }
  }, {
    key: "removeItem",
    value: function removeItem(key) {
      delete this._memoryCache[key];
      this.persist();
    }
  }, {
    key: "clear",
    value: function clear() {
      for (var key in this._memoryCache) {
        delete this._memoryCache[key];
      }
      this.persist();
    }
  }, {
    key: "getAllKeys",
    value: function getAllKeys() {
      return Object.keys(this._memoryCache);
    }
  }]);
  return SemiAsyncStorage;
}();
exports.SemiAsyncStorage = SemiAsyncStorage;